import { render, staticRenderFns } from "./share-tips-popup.vue?vue&type=template&id=8d9faf64&scoped=true"
import script from "./share-tips-popup.vue?vue&type=script&lang=js"
export * from "./share-tips-popup.vue?vue&type=script&lang=js"
import style0 from "./share-tips-popup.vue?vue&type=style&index=0&id=8d9faf64&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_4rliqqz3ui7xo7iaw2ukiguuga/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d9faf64",
  null
  
)

export default component.exports